/* global WC */
import ShortUrlEmbed from '@shared-vue-components/components/asiagoit-redirects/ShortUrlEmbed.vue'
import {NConfigProvider} from 'naive-ui'
import {createApp, h, Suspense} from 'vue'

const app = createApp({
  setup() {
    return () =>
      h(
        NConfigProvider,
        {
          preflightStyleDisabled: true,
        },
        h(
          Suspense,
          {timeout: 0},
          h(ShortUrlEmbed, {
            url: `${window.location.origin}${window.location.pathname}#content-start`,
            isAdmin: WC.isWebcloud,
          })
        )
      )
  },
})

document.addEventListener('cmsVueComponentsReady', () => {
  app.mount('[data-cms-vue-component="short-url-embed"]')
})
